import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from 'react';
import { ToastError } from "../../assets/ToastError";
import BlsGridTitle from '../../components/BlsGridTitle';
import BlsButton from "../../components/ui-common/Button/BlsButton";
import BlsGridTable, { useBlsGridTable } from "../../components/ui-common/GridTable/BlsGridTable";
import Loader from "../../components/ui-common/Loader/Loader";

import { toast } from "react-toastify";
import BlsInput, { useBlsInput } from '../../components/ui-common/Input/BlsInput';
import BlsSelect, { useBlsSelect } from '../../components/ui-common/Select/BlsSelect';

import { TooltipComponent } from "@syncfusion/ej2-react-popups";
import { CgClose } from "react-icons/cg";
import { FiSettings } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import { convertToCurrencyByKey, convertToDateFormat, isNullOrEmpty } from "../../assets/UtilMethods";
import { ThemeSettings } from "../../components";
import ParameterConstants from "../../constants/ParameterConstants";
import { useStateContext } from "../../contexts/ContextProvider";
import belsoftCore from '../../core/index.ts';
import EstateCurrentMarketValueForm from "./EstateCurrentMarketValueForm";


const TapuRayicBedel = () => {
    const columnEstateDeclarationsListWithDeclarationDebt = useBlsGridTable(
        [
            { headerCheckboxSelection: true, headerCheckboxSelectionFilteredOnly: true, checkboxSelection: true, width: 50, minWidth: 50, suppressSizeToFit: true, pinned: 'left' },
            { headerName: "TC Kimlik/Vergi/Sicil No", field: "DeclarationRegistry.Registry.RegistryInfo.IdentityNumber", suppressSizeToFit: true, sortable: true, width: 90, minWidth: 50 },
            { headerName: "Ad Soyad/Unvan", valueGetter: x => { return `${x.data.DeclarationRegistry.Registry.RegistryInfo.Name} ${x.data.DeclarationRegistry.Registry.RegistryInfo.SurName}` }, field: "DeclarationRegistry.Registry.RegistryInfo.Name", suppressSizeToFit: true, sortable: true, width: 90, minWidth: 50 },
            { headerName: "Beyan Türü", field: "Estate.EstateType.TypeName", width: 120, minWidth: 50, suppressSizeToFit: true },
            { headerName: "Beyan Tipi", field: "EstateDeclarationBuilding.EstateUsageType.UsageTypeName", width: 120, minWidth: 50, suppressSizeToFit: true },
            { headerName: "Beyan Sıra", field: "DeclarationOrder", width: 120, minWidth: 50, suppressSizeToFit: true },
            { headerName: "Beyan Tarihi", valueGetter: (data) => convertToDateFormat(data.data.DeclarationAcceptenceDate), width: 120, minWidth: 50, suppressSizeToFit: true },
            { headerName: "Cilt", field: "Estate.BookNo", width: 120, minWidth: 50, suppressSizeToFit: true },
            { headerName: "Sayfa", field: "Estate.PageNo", width: 120, minWidth: 50, suppressSizeToFit: true },
            { headerName: "Ada", field: "Estate.BlockOfBuildings", width: 120, minWidth: 50, suppressSizeToFit: true },
            { headerName: "Parsel", field: "Estate.Parcel", width: 120, minWidth: 50, suppressSizeToFit: true },
            { headerName: "Bağımsız Bölüm", field: "Estate.DetachedSectionNo", width: 120, minWidth: 50, suppressSizeToFit: true },
            { headerName: "Arsa Alanı", field: "Estate.LandArea", width: 120, minWidth: 50, suppressSizeToFit: true },
            { headerName: "Bina Alanı", field: "EstateDeclarationBuilding.BuildingArea", width: 120, minWidth: 50, suppressSizeToFit: true },
            { headerName: "Beyan Borç", field: "DeclarationDebt", cellRenderer: x => convertToCurrencyByKey(x), width: 120, minWidth: 50, suppressSizeToFit: true, cellClass: 'ag-right-aligned-cell', headerClass: 'ag-header-text-align-centered' },
            { headerName: "Adres", field: "Estate.AddressSource.AddressString", width: 120, minWidth: 50, suppressSizeToFit: true, tooltipField: 'Estate.AddressSource.AddressString' },
            { headerName: "Beyan Durum", field: "DeclarationStatus.ParameterName", width: 120, minWidth: 50, suppressSizeToFit: true },
        ]
    )

    const columnEstateDeclarationsListWithoutDeclarationDebt = useBlsGridTable(
        [
            { headerCheckboxSelection: true, headerCheckboxSelectionFilteredOnly: true, checkboxSelection: true, width: 50, minWidth: 50, suppressSizeToFit: true, pinned: 'left' },
            { headerName: "TC Kimlik/Vergi/Sicil No", field: "DeclarationRegistry.Registry.RegistryInfo.IdentityNumber", suppressSizeToFit: true, sortable: true, width: 90, minWidth: 50 },
            { headerName: "Ad Soyad/Unvan", valueGetter: x => { return `${x.data.DeclarationRegistry.Registry.RegistryInfo.Name} ${x.data.DeclarationRegistry.Registry.RegistryInfo.SurName}` }, field: "DeclarationRegistry.Registry.RegistryInfo.Name", suppressSizeToFit: true, sortable: true, width: 90, minWidth: 50 },
            { headerName: "Beyan Türü", field: "Estate.EstateType.TypeName", width: 120, minWidth: 50, suppressSizeToFit: true },
            { headerName: "Beyan Tipi", field: "EstateDeclarationBuilding.EstateUsageType.UsageTypeName", width: 120, minWidth: 50, suppressSizeToFit: true },
            { headerName: "Beyan Sıra", field: "DeclarationOrder", width: 120, minWidth: 50, suppressSizeToFit: true },
            { headerName: "Beyan Tarihi", valueGetter: (data) => convertToDateFormat(data.data.DeclarationAcceptenceDate), width: 120, minWidth: 50, suppressSizeToFit: true },
            { headerName: "Cilt", field: "Estate.BookNo", width: 120, minWidth: 50, suppressSizeToFit: true },
            { headerName: "Sayfa", field: "Estate.PageNo", width: 120, minWidth: 50, suppressSizeToFit: true },
            { headerName: "Ada", field: "Estate.BlockOfBuildings", width: 120, minWidth: 50, suppressSizeToFit: true },
            { headerName: "Parsel", field: "Estate.Parcel", width: 120, minWidth: 50, suppressSizeToFit: true },
            { headerName: "Bağımsız Bölüm", field: "Estate.DetachedSectionNo", width: 120, minWidth: 50, suppressSizeToFit: true },
            { headerName: "Arsa Alanı", field: "Estate.LandArea", width: 120, minWidth: 50, suppressSizeToFit: true },
            { headerName: "Bina Alanı", field: "EstateDeclarationBuilding.BuildingArea", width: 120, minWidth: 50, suppressSizeToFit: true },
            { headerName: "Adres", field: "Estate.AddressSource.AddressString", width: 120, minWidth: 50, suppressSizeToFit: true, tooltipField: 'Estate.AddressSource.AddressString' },
            { headerName: "Beyan Durum", field: "DeclarationStatus.ParameterName", width: 120, minWidth: 50, suppressSizeToFit: true },
        ]
    )

    const [loading, setLoading] = useState(false);
    const cboQueryType = useBlsSelect({ label: "Rapor Tipi:", optionValue: "ParameterCode", optionLabel: "ParameterName", allowBlank: false })
    const txtQueryCriteria = useBlsInput({ label: "TC Kimlik/Vergi/Sicil No:", allowBlank: false })
    const txtBlockOfBuildings = useBlsInput({ label: "Ada:", allowBlank: false })
    const txtParcel = useBlsInput({ label: "Parsel:", allowBlank: false })
    const [grdEstateDeclarations, setGrdEstateDeclarations] = useState([])
    const navigate = useNavigate();
    const { currentColor, themeSettings, setThemeSettings } = useStateContext();

    const [openReportParameterWindow, setOpenReportParameterWindow] = useState(false)
    const [cityList, setCityList] = useState([])
    const [currentMarketValueReportTypeList, setCurrentMarketValueReportTypeList] = useState([])
    const [cboReportType, setCboReportType] = useState({})
    const [txtReportNumber, setTxtReportNumber] = useState("")
    const [txtSubject, setTxtSubject] = useState("")
    const [txtTopTitleFirst, setTxtTopTitleFirst] = useState("")
    const [txtTopTitleSecond, setTxtTopTitleSecond] = useState("")
    const [txtTopTitleThird, setTxtTopTitleThird] = useState("")
    const [txtTopTitleFourth, setTxtTopTitleFourth] = useState("")
    const [txtTargetInstitution, setTxtTargetInstitution] = useState("")
    const [cboCities, setCboCities] = useState({})
    const [txtTargetCounty, setTxtTargetCounty] = useState("")
    const [txtBodyText, setTxtBodyText] = useState("")
    const [txtFootNoteFirst, setTxtFootNoteFirst] = useState("")
    const [txtFootNoteSecond, setTxtFootNoteSecond] = useState("")
    const [txtFootNoteThird, setTxtFootNoteThird] = useState("")
    const [txtFootNoteFourth, setTxtFootNoteFourth] = useState("")
    const [txtConcurrenceInfo, setTxtConcurrenceInfo] = useState("")
    const [txtEstateDeclarationYear, setTxtEstateDeclarationYear] = useState("")
    const [concreteCurrentMarketValueReportData, setConcreteCurrentMarketValueReportData] = useState({})
    const [isReportOpen, setIsReportOpen] = useState(false)
    const [isReportBtnDisabled, setIsReportBtnDisabled] = useState(false)
    const [cmvReportDetailList, setCmvReportDetailList] = useState([]);
    const [columnEstateDeclarationsList, setColumnEstateDeclarationsList] = useState(columnEstateDeclarationsListWithDeclarationDebt);
    const gridRef = useRef(null);

    const [personnellOnCMVReport, setPersonnellOnCMVReport] = useState({})
    const [selectedRegistry, setSelectedRegistry] = useState(null)
    const currentMarketValueReportParameter = useRef(null);

    useEffect(() => {
        async function PageLoad() {
            try {
                setLoading(true);

                if (sessionStorage.getItem("userInfo") === null) {
                    navigate(ParameterConstants.URL_EXTENSION + "/Login");
                } else {
                    const userInfo = JSON.parse(sessionStorage.getItem("userInfo"));

                    let queryTypeList = [];
                    queryTypeList.push({ ParameterCode: "1", ParameterName: "TC Kimlik No" });
                    queryTypeList.push({ ParameterCode: "2", ParameterName: "Vergi No" });
                    cboQueryType.setOptionList(queryTypeList);

                    const currentMarketValueReportParameter_ = (await belsoftCore.services.tapuService.retrieveCurrentMarketValueReportParameter())[0];
                    currentMarketValueReportParameter.current = currentMarketValueReportParameter_;
                }

                setLoading(false);
            } catch (e) {
                setLoading(false);
                ToastError(e)
                return;
            }
        }

        PageLoad();
    }, [])

    const pageStyle = {
        labelStyle: {
            borderWidth: '1px',
            borderColor: '#f0f0f0',
            borderRadius: 3,
            width: '38%',
            height: '20px',
            fontSize: '12px',
            color: "black",
            float: "left",
            marginLeft: "2%",
            textAlign: "left",
            backgroundColor: "transparent",
            overflow: "hidden"
        },

        buttonStyle: {
            color: "#fff",
            width: "auto",
            minWidth: "100",
            paddingLeft: "15px",
            paddingRight: "15px",
            textTransform: "capitalize"

        },

        inputStyle: {
            boxShadow: '1px 1px 5px #aeaeae',
            borderWidth: '1px',
            borderColor: '#f0f0f0',
            borderRadius: 3,
            width: '50%',
            marginLeft: "0%",
            height: '20px',
            float: "left",
            fontSize: '12px'
        },
        textAreaStyle: {
            boxShadow: '1px 1px 5px #aeaeae',
            borderWidth: '1px',
            borderColor: '#f0f0f0',
            borderRadius: 3,
            width: '50%',
            marginLeft: "0%",
            height: '50px',
            float: "left",
            marginBottom: '1%',
            fontSize: '12px'
        },
        inputSelectStyle: {
            control: (provided, state) => ({
                ...provided,
                background: '#fff',
                minHeight: '20px',
                height: '20px',
                border: '1px',
                borderColor: '#aeaeae',
                borderWidth: '1px',
                boxShadow: state.isFocused ? '1px 1px 5px #aeaeae' : '1px 1px 5px #aeaeae',
                fontSize: '12px',
                color: '#000',
                width: "100%",
                marginLeft: "0%",
                //fontWeight:'bold',
            }),

            valueContainer: (provided, state) => ({
                ...provided,
                height: '20px',
                padding: '0 1px',
                fontSize: '12px',
                color: '#000',
                fontWeight: '500',
            }),

            input: (provided, state) => ({
                ...provided,
                margin: '0px',
                fontWeight: 'bold',
            }),
            indicatorSeparator: state => ({
                display: 'none',
            }),
            indicatorsContainer: (provided, state) => ({
                ...provided,
                height: '20px',
            }),
            placeholder: styles => ({ ...styles, fontSize: "0.6vw", display: "inline-block", float: "left" }),
            option: (styles, { data, isDisabled, isFocused, isSelected }) => {
                return {
                    ...styles,
                    color: '#000',
                    fontSize: '12px',
                    textAlign: 'left',
                    fontWeight: 'bold',
                };
            },
        },

        SelectInputStyle: {
            boxShadow: '1px 1px 5px #aeaeae',
            borderWidth: '1px',
            borderColor: '#f0f0f0',
            borderRadius: 3,
            width: '50%',
            marginLeft: "0%",
            height: '20px',
            float: "left",
            textAlign: "left"
        },
    }


    const retrieveEstateDeclarations = async () => {
        if (!isNullOrEmpty(cboQueryType.value?.ParameterCode) && isNullOrEmpty(txtQueryCriteria.value)) {
            toast.warning("TC Kimlik/Vergi/Sicil No alanı boş olamaz.", { theme: 'dark' })
            return;
        } else if (!isNullOrEmpty(txtQueryCriteria.value) && cboQueryType.value === null) {
            toast.warning("Lütfen sorgu tipini seçiniz.", { theme: 'dark' })
            return;
        } else if (isNullOrEmpty(txtQueryCriteria.value) && cboQueryType.value === null) {
            if (isNullOrEmpty(txtBlockOfBuildings.value) || isNullOrEmpty(txtParcel.value)) {
                toast.warning("Başka kriter seçilmediğinde ada veya parsel alanı boş olamaz.", { theme: 'dark' })
                return;
            }
        }
        try {
            setLoading(true);
            let queryType = cboQueryType.value?.ParameterCode;
            if (isNullOrEmpty(queryType)) {
                queryType = "4"; //ada/parsel
            }
            let estateDeclarationList = await belsoftCore.services.tapuService.getEstateDeclarationsByRegistryAndEstateInfo(queryType, isNullOrEmpty(txtQueryCriteria.value) ? null : txtQueryCriteria.value, txtBlockOfBuildings.value, txtParcel.value, true, 1990, 1, 1, "1");
            if (estateDeclarationList !== null) {
                if (cboQueryType.isNullOrEmpty() && txtQueryCriteria.isNullOrEmpty() && queryType === "4") {
                    setColumnEstateDeclarationsList(columnEstateDeclarationsListWithoutDeclarationDebt);
                } else {
                    setColumnEstateDeclarationsList(columnEstateDeclarationsListWithDeclarationDebt);
                }

                setGrdEstateDeclarations(estateDeclarationList);
            }
            setLoading(false);
        } catch (e) {
            setLoading(false);
            ToastError(e)
            return;
        }
    }

    const WithLayoutComponent = ({ children }) => {
        return <div className="flex relative dark:bg-main-dark-bg">
            <div className="fixed right-4 bottom-4" style={{ zIndex: '1000' }}>
                <TooltipComponent
                    content="Settings"
                    position="Top"
                >
                    <button
                        type="button"
                        onClick={() => setThemeSettings(true)}
                        style={{ background: currentColor, borderRadius: '50%' }}
                        className="text-3xl text-white p-3 hover:drop-shadow-xl hover:bg-light-gray"
                    >
                        <FiSettings />
                    </button>

                </TooltipComponent>
            </div>
            <div
            >
                <div className="fixed md:static bg-main-bg dark:bg-main-dark-bg mt/5 w-full ">
                </div>
                <div>
                    {themeSettings && (<ThemeSettings />)}

                    {children}
                </div>
            </div>
        </div>
    }

    const openReportParametersWindow = async () => {
        try {
            let addedIdentityNumbers = [];
            gridRef.current.api.getSelectedRows().forEach(ed => {
                if (ed.DeclarationRegistry.Registry.RegistryInfo.IdentityNumber !== null) {
                    addedIdentityNumbers.push(ed.DeclarationRegistry.Registry.RegistryInfo.IdentityNumber);
                }
            });

            if (addedIdentityNumbers.length > 0) {
                let distinctIdentityNumbers = [...new Set(addedIdentityNumbers)];
                if (distinctIdentityNumbers.length > 1) {
                    toast.warning('Lütfen aynı sicil numarasına ait beyanları seçiniz!', { position: "top-center", autoClose: 5000, theme: 'dark', });
                    return
                }
            }

            let selectedDeclarations = gridRef.current.api.getSelectedRows();
            if (gridRef.current.api.getSelectedRows().length === 0) {
                toast.warning('Lütfen beyan seçimi yapınız!', { position: "top-center", autoClose: 5000, theme: 'dark', });
                return
            }

            let i = 1;
            gridRef.current.api.getSelectedRows().forEach(ed => {
                if (ed.EstateDeclarationAnnotationList !== null && (ed.EstateDeclarationAnnotationList.filter(edd => edd.AnnotationEndDate === null)).length > 0) {
                    toast.warning(i + ".sıradaki beyanda şerh vardır." + " Lütfen önce şerhi kaldırınız !", { position: "top-center", autoClose: 5000, theme: 'dark', })
                    return
                }
                i++;
            });

            let parameterServiceConcreteCurrentMarketValueReportParameter = currentMarketValueReportParameter.current;
            let concreteCurrentMarketValueReportParameter = parameterServiceConcreteCurrentMarketValueReportParameter;

            let cityList_ = await belsoftCore.services.tapuService.getCityList();
            setCityList(cityList_[0]);
            let currentMarketValueReportTypes = await belsoftCore.services.tapuService.retrieveParametersWithoutAuthorization("380")
            setCurrentMarketValueReportTypeList(currentMarketValueReportTypes[0])

            if (concreteCurrentMarketValueReportParameter) {
                await fillFields(concreteCurrentMarketValueReportParameter, gridRef.current.api.getSelectedRows()[0]);
            }

            setOpenReportParameterWindow(true);
            setPersonnellOnCMVReport(currentMarketValueReportParameter.current?.UserDetail);
            setSelectedRegistry(selectedDeclarations[0].DeclarationRegistry.Registry)
        } catch (e) {
            setLoading(false);
            toast.warning(e.message);
        }
    }

    const GetConcreteCurrentMarketValueReportParameter = () => {
        let concreteCurrentMarketValueReportParameter = {};
        concreteCurrentMarketValueReportParameter.Subject = txtSubject;
        concreteCurrentMarketValueReportParameter.TopTitleFirst = txtTopTitleFirst;
        concreteCurrentMarketValueReportParameter.TopTitleSecond = txtTopTitleSecond;
        concreteCurrentMarketValueReportParameter.TopTitleThird = txtTopTitleThird;
        concreteCurrentMarketValueReportParameter.TopTitleFourth = txtTopTitleFourth;
        concreteCurrentMarketValueReportParameter.TargetInstitution = txtTargetInstitution;
        concreteCurrentMarketValueReportParameter.UserDetail = personnellOnCMVReport;
        concreteCurrentMarketValueReportParameter.TargetCity = cboCities;
        concreteCurrentMarketValueReportParameter.TargetCountyName = txtTargetCounty;
        concreteCurrentMarketValueReportParameter.BodyText = txtBodyText;
        concreteCurrentMarketValueReportParameter.FootNoteFirst = txtFootNoteFirst;
        concreteCurrentMarketValueReportParameter.FootNoteSecond = txtFootNoteSecond;
        concreteCurrentMarketValueReportParameter.FootNoteThird = txtFootNoteThird;
        concreteCurrentMarketValueReportParameter.FootNoteFourth = txtFootNoteFourth;

        return concreteCurrentMarketValueReportParameter;
    }

    const GetPrmConcreteCurrentMarketValueReportParameter = () => {
        let prmConcreteCurrentMarketValueReportParameter = {};
        prmConcreteCurrentMarketValueReportParameter.Subject = txtSubject;
        prmConcreteCurrentMarketValueReportParameter.TopTitleFirst = txtTopTitleFirst;
        prmConcreteCurrentMarketValueReportParameter.TopTitleSecond = txtTopTitleSecond;
        prmConcreteCurrentMarketValueReportParameter.TopTitleThird = txtTopTitleThird;
        prmConcreteCurrentMarketValueReportParameter.TopTitleFourth = txtTopTitleFourth;
        prmConcreteCurrentMarketValueReportParameter.TargetInstitution = txtTargetInstitution;
        prmConcreteCurrentMarketValueReportParameter.UserDetail = { Registry: null }
        if (personnellOnCMVReport !== null) {
            prmConcreteCurrentMarketValueReportParameter.UserDetail = { ...personnellOnCMVReport };
        }


        let prmSelectedCity = cboCities


        prmConcreteCurrentMarketValueReportParameter.TargetCity = prmSelectedCity;
        prmConcreteCurrentMarketValueReportParameter.TargetCountyName = txtTargetCounty;
        prmConcreteCurrentMarketValueReportParameter.BodyText = txtBodyText;
        prmConcreteCurrentMarketValueReportParameter.FootNoteFirst = txtFootNoteFirst;
        prmConcreteCurrentMarketValueReportParameter.FootNoteSecond = txtFootNoteSecond;
        prmConcreteCurrentMarketValueReportParameter.FootNoteThird = txtFootNoteThird;
        prmConcreteCurrentMarketValueReportParameter.FootNoteFourth = txtFootNoteFourth;

        return prmConcreteCurrentMarketValueReportParameter;
    }


    const fillFields = async (concreteCurrentMarketValueReportParameter, concreteEstateDeclaration) => {
        try {
            let nextReportNumber = await belsoftCore.services.tapuService.getNextCurrentMarketValueReportNumber();
            setTxtReportNumber(nextReportNumber.toString())

            let concurrenceInfo = "";
            if (!concreteEstateDeclaration.ShareType === "0" && concreteEstateDeclaration.Concurrences) {
                concurrenceInfo += "Müşterek/El Birliği: ";
            }
            setTxtFootNoteThird("")
            setTxtTopTitleFourth("")
            setTxtConcurrenceInfo("")
            setTxtSubject(concreteCurrentMarketValueReportParameter.Subject);
            setTxtTopTitleFirst(concreteCurrentMarketValueReportParameter.TopTitleFirst);
            setTxtTopTitleSecond(concreteCurrentMarketValueReportParameter.TopTitleSecond);
            setTxtTopTitleThird(concreteCurrentMarketValueReportParameter.TopTitleThird);
            setTxtTopTitleFourth(concreteCurrentMarketValueReportParameter.TopTitleFourth);
            setTxtTargetInstitution(concreteCurrentMarketValueReportParameter.TargetInstitution);
            setCboCities(concreteCurrentMarketValueReportParameter.TargetCity);
            setTxtTargetCounty();
            setTxtBodyText(concreteCurrentMarketValueReportParameter.BodyText);
            setTxtFootNoteFirst(concreteCurrentMarketValueReportParameter.FootNoteFirst);
            setTxtFootNoteSecond(concreteCurrentMarketValueReportParameter.FootNoteSecond);
            setTxtFootNoteThird(concreteCurrentMarketValueReportParameter.FootNoteThird);
            setTxtFootNoteFourth(concreteCurrentMarketValueReportParameter.FootNoteFourth);
            setTxtConcurrenceInfo(concurrenceInfo)

        } catch (e) {
            setLoading(false);
            toast.warning(e.message);
        }
    }

    const createCurrentMarketValueReport = async () => {
        try {
            if (!Object.keys(cboReportType).length > 0) {
                toast.warning('Lütfen Rapor Tipi Seçiniz', { position: "top-center", autoClose: 5000, theme: 'dark', });
                return
            }
            setIsReportBtnDisabled(true)
            toast.info('Rapor oluşturuluyor. Lütfen bekleyiniz.', { position: "top-center", autoClose: 5000, theme: 'dark', });
            let currentMarketValueReportNumber = txtReportNumber;
            let declarationYear = txtEstateDeclarationYear

            let concreteEstateDeclarationRegistry = null;

            if (selectedRegistry) concreteEstateDeclarationRegistry = await belsoftCore.services.tapuService.getConcreteEstateDeclarationRegistry(selectedRegistry);

            let currentCurrentMarketValueReportParameter = GetConcreteCurrentMarketValueReportParameter();
            let concreteEstateDeclarationList = gridRef.current.api.getSelectedRows();

            let concreteCurrentMarketValueReport = {};
            concreteCurrentMarketValueReport.ReportNumber = currentMarketValueReportNumber;
            concreteCurrentMarketValueReport.DeclarationYear = declarationYear;
            concreteCurrentMarketValueReport.EstateDeclarationRegistry = concreteEstateDeclarationRegistry;

            await Promise.all(concreteEstateDeclarationList.map(async (concreteEstateDeclaration) => {
                try {
                    if (concreteEstateDeclaration.EstateDeclarationAccrumentDetail === null || concreteEstateDeclaration.EstateDeclarationAccrumentDetail.EstateDeclarationDetailList === null ||
                        concreteEstateDeclaration.EstateDeclarationAccrumentDetail.EstateDeclarationDetailList.length === 0) {
                        concreteEstateDeclaration.EstateDeclarationAccrumentDetail = await belsoftCore.services.tapuService.getDeclarationAccrumentDetail(concreteEstateDeclaration.Oid);
                    }
                } catch (e) {
                    setLoading(false);
                    toast.warning(e.message);
                }
            }))

            concreteCurrentMarketValueReport.EstateDeclarationList = concreteEstateDeclarationList;

            //Girilen Parametreleri alır ve kayda gönderir, varsa kaydetmez.
            let prmConcreteCurrentMarketValueReportParameter = GetPrmConcreteCurrentMarketValueReportParameter();
            prmConcreteCurrentMarketValueReportParameter.IsDefaultCurrentMarketValueReportParameter = false;
            prmConcreteCurrentMarketValueReportParameter = (await belsoftCore.services.tapuService.saveCurrentMarketValueReportParameter(prmConcreteCurrentMarketValueReportParameter))[0];

            //Kayıttan Dönen Parametre nin Oid sini setler.
            currentCurrentMarketValueReportParameter.Oid = prmConcreteCurrentMarketValueReportParameter.Oid;
            currentCurrentMarketValueReportParameter.LastUpdated = prmConcreteCurrentMarketValueReportParameter.LastUpdated;
            currentCurrentMarketValueReportParameter.OperationRefNo = prmConcreteCurrentMarketValueReportParameter.OperationRefNo;

            //Oid li Parametreyi Rapora Ekler.
            concreteCurrentMarketValueReport.CurrentMarketValueReportParameter = currentCurrentMarketValueReportParameter;
            //Çıktısı alınan Raporu kaydeder. (Tekrar çıktısı alınabilme durumu için)
            concreteCurrentMarketValueReport.IsFreeOfCharge = false;
            concreteCurrentMarketValueReport.IsOuterRequest = true;


            concreteCurrentMarketValueReport = (await belsoftCore.services.tapuService.createMarketValueReport(concreteCurrentMarketValueReport, cboReportType.ParameterCode))[0];
            concreteCurrentMarketValueReport.CurrentMarketValueReportParameter.UserDetail = currentCurrentMarketValueReportParameter?.UserDetail
            setConcreteCurrentMarketValueReportData(concreteCurrentMarketValueReport);

            if (concreteEstateDeclarationRegistry && concreteEstateDeclarationRegistry?.Oid) {
                let cmvReportDetailList_ = await belsoftCore.services.tapuService.retrieveCmvReportDetails(concreteEstateDeclarationRegistry.Oid);
                setCmvReportDetailList(cmvReportDetailList_)
            }


            let result = await belsoftCore.services.tapuService.checkCurrentMarketValueReportDeclarationDebt(concreteCurrentMarketValueReport);
            if (typeof (result) === 'string') {
                toast.warning(result, { theme: 'dark', })
                setLoading(false);
                setOpenReportParameterWindow(false)
                setIsReportBtnDisabled(false)
                return
            }
            setOpenReportParameterWindow(false)
            setIsReportBtnDisabled(false)
            setIsReportOpen(true)

        } catch (e) {
            setIsReportBtnDisabled(false)
            setLoading(false);
            toast.warning(e.message, { theme: 'dark', });
        }
    }

    return (
        <div className="bg-main-bg dark:bg-main-dark-bg">
            <WithLayoutComponent />
            <Loader isLoading={loading} />
            <BlsGridTitle title="">
                <div style={{ padding: '1%' }}>Ada parsel ile sorgu yapmak istiyorsanız  Rapor Tipi seçmeden devam ediniz.</div>
                <Grid item container xs={12}>
                    <Grid item xs={3}>
                        <BlsSelect inputState={cboQueryType} isClearable />
                        <BlsButton type="search" buttonStyle={{ marginTop: "2%" }} onClick={retrieveEstateDeclarations}></BlsButton>
                        <BlsButton type="reportGroup" buttonStyle={{ marginTop: "2%" }} onClick={openReportParametersWindow}>Rayiç Bedel Raporu</BlsButton>
                    </Grid>
                    <Grid item xs={3}>
                        <BlsInput inputState={txtQueryCriteria} />
                    </Grid>
                    <Grid item xs={3}>
                        <BlsInput inputState={txtBlockOfBuildings} />
                    </Grid>
                    <Grid item xs={3}>
                        <BlsInput inputState={txtParcel} />
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <Grid item xs={12} style={{ marginLeft: "0.5%", height: "780px", marginRight: "0.5%", marginTop: "1.5%" }}>
                        <BlsGridTable
                            ref={gridRef}
                            columnDefs={columnEstateDeclarationsList}
                            rowData={grdEstateDeclarations}
                            rowSelection="multiple"
                        />
                    </Grid>
                </Grid>
            </BlsGridTitle>

            {
                <div style={{ width: '30vw' }}>
                    <Dialog
                        onClose={() => setOpenReportParameterWindow(false)}
                        aria-labelledby="customized-dialog-title"
                        open={openReportParameterWindow}
                    >
                        <DialogTitle>
                            <Box display="flex" alignItems="center">
                                <Box flexGrow={1}><Typography>Rapor Parametre Bilgileri</Typography></Box>
                                <Box>
                                    <IconButton onClick={() => setOpenReportParameterWindow(false)}>
                                        <CgClose style={{ color: "#000" }} />
                                    </IconButton>
                                </Box>
                            </Box>
                        </DialogTitle>
                        <DialogContent dividers style={{ width: '30vw' }}>
                            <div className="apllicationProcessDiv" >
                                <label style={pageStyle.labelStyle} className="inputs">Beyan Yılı:</label>
                                <input value={txtEstateDeclarationYear} onChange={(e) => { setTxtEstateDeclarationYear(e.target.value) }} style={pageStyle.inputStyle} className="inputs" type='number' />
                                <br></br>
                            </div>
                            <div className="apllicationProcessDiv">
                                <label style={pageStyle.labelStyle} className="inputs">Rapor Tipi: </label>
                                <div style={pageStyle.SelectInputStyle}>
                                    <Select
                                        value={cboReportType}
                                        isClearable
                                        styles={pageStyle.inputSelectStyle}
                                        options={currentMarketValueReportTypeList}
                                        placeholder='Rapor Tipi Seçiniz..'
                                        getOptionLabel={(option) => option.ParameterName}
                                        getOptionValue={(option) => option.ParameterCode}
                                        onChange={value => { setCboReportType(value) }}
                                        //isClearable={true}
                                        //isRtl={isRtl}
                                        isSearchable={true}
                                        name="color" />
                                </div>
                                <br></br>
                            </div>
                            <div className="apllicationProcessDiv" >
                                <label style={pageStyle.labelStyle} className="inputs">Son Sayı No:</label>
                                <input value={txtReportNumber} onChange={(e) => { setTxtReportNumber(e.target.value) }} style={pageStyle.inputStyle} className="inputs" type='text' />
                                <br></br>
                            </div>
                            <div className="apllicationProcessDiv" >
                                <label style={pageStyle.labelStyle} className="inputs">Konu:</label>
                                <input value={txtSubject} onChange={(e) => { setTxtSubject(e.target.value) }} style={pageStyle.inputStyle} className="inputs" type='text' />
                                <br></br>
                            </div>
                            <div className="apllicationProcessDiv" >
                                <label style={pageStyle.labelStyle} className="inputs">Üst Başlık 1:</label>
                                <input value={txtTopTitleFirst} onChange={(e) => { setTxtTopTitleFirst(e.target.value) }} style={pageStyle.inputStyle} className="inputs" type='text' />
                                <br></br>
                            </div>
                            <div className="apllicationProcessDiv" >
                                <label style={pageStyle.labelStyle} className="inputs">Üst Başlık 2:</label>
                                <input value={txtTopTitleSecond} onChange={(e) => { setTxtTopTitleSecond(e.target.value) }} style={pageStyle.inputStyle} className="inputs" type='text' />
                                <br></br>
                            </div>
                            <div className="apllicationProcessDiv" >
                                <label style={pageStyle.labelStyle} className="inputs">Üst Başlık 3:</label>
                                <input value={txtTopTitleThird} onChange={(e) => { setTxtTopTitleThird(e.target.value) }} style={pageStyle.inputStyle} className="inputs" type='text' />
                                <br></br>
                            </div>
                            <div className="apllicationProcessDiv" >
                                <label style={pageStyle.labelStyle} className="inputs">Üst Başlık 4:</label>
                                <input value={txtTopTitleFourth} onChange={(e) => { setTxtTopTitleFourth(e.target.value) }} style={pageStyle.inputStyle} className="inputs" type='text' />
                                <br></br>
                            </div>
                            <div className="apllicationProcessDiv" >
                                <label style={pageStyle.labelStyle} className="inputs">GidecEği Yer:</label>
                                <input value={txtTargetInstitution} onChange={(e) => { setTxtTargetInstitution(e.target.value) }} style={pageStyle.inputStyle} className="inputs" type='text' />
                                <br></br>
                            </div>
                            <div className="apllicationProcessDiv">
                                <label style={pageStyle.labelStyle} className="inputs">Gideceği İl: </label>
                                <div style={pageStyle.SelectInputStyle}>
                                    <Select
                                        value={cboCities}
                                        styles={pageStyle.inputSelectStyle}
                                        options={cityList}
                                        placeholder='İlçe Seçiniz..'
                                        getOptionLabel={(option) => option.CityName}
                                        getOptionValue={(option) => option.ISSCode}
                                        onChange={value => { setCboCities(value) }}
                                        //isClearable={true}
                                        //isRtl={isRtl}
                                        isSearchable={true}
                                        name="color" />
                                </div>
                                <br></br>
                            </div>
                            <div className="apllicationProcessDiv" >
                                <label style={pageStyle.labelStyle} className="inputs">Gideceği İlçe:</label>
                                <input value={txtTargetCounty} onChange={(e) => { setTxtTargetCounty(e.target.value) }} style={pageStyle.inputStyle} className="inputs" type='text' />
                                <br></br>
                            </div>
                            <div className="apllicationProcessDiv" >
                                <label style={pageStyle.labelStyle} className="inputs">Metin:</label>
                                <textarea value={txtBodyText} onChange={(e) => { setTxtBodyText(e.target.value) }} style={pageStyle.textAreaStyle} className="inputs" type='textarea' />
                                <br></br>
                            </div>


                            <div className="apllicationProcessDiv" >
                                <label style={pageStyle.labelStyle} className="inputs">Alt Not 1:</label>
                                <input value={txtFootNoteFirst} onChange={(e) => { setTxtFootNoteFirst(e.target.value) }} style={pageStyle.inputStyle} className="inputs" type='text' />
                                <br></br>
                            </div>
                            <div className="apllicationProcessDiv" >
                                <label style={pageStyle.labelStyle} className="inputs">Alt Not 2:</label>
                                <input value={txtFootNoteSecond} onChange={(e) => { setTxtFootNoteSecond(e.target.value) }} style={pageStyle.inputStyle} className="inputs" type='text' />
                                <br></br>
                            </div>
                            <div className="apllicationProcessDiv" >
                                <label style={pageStyle.labelStyle} className="inputs">Alt Not 3:</label>
                                <input value={txtFootNoteThird} onChange={(e) => { setTxtFootNoteThird(e.target.value) }} style={pageStyle.inputStyle} className="inputs" type='text' />
                                <br></br>
                            </div>
                            <div className="apllicationProcessDiv" >
                                <label style={pageStyle.labelStyle} className="inputs">Alt Not 4:</label>
                                <input value={txtFootNoteFourth} onChange={(e) => { setTxtFootNoteFourth(e.target.value) }} style={pageStyle.inputStyle} className="inputs" type='text' />
                                <br></br>
                            </div>
                            <div className="apllicationProcessDiv" >
                                <label style={pageStyle.labelStyle} className="inputs">Müşterek/El Birliği:</label>
                                <input value={txtConcurrenceInfo} onChange={(e) => {
                                    setTxtConcurrenceInfo(e.target.value)
                                }} style={pageStyle.inputStyle} className="inputs" type='text' />
                                <br></br>
                            </div>
                        </DialogContent>
                        <DialogActions style={{ pointerEvents: isReportBtnDisabled ? 'none' : 'auto' }}>
                            <Button color="primary" variant="contained" disabled={isReportBtnDisabled} onClick={createCurrentMarketValueReport}>
                                Rapor Oluştur
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
            }

            {isReportOpen &&
                <EstateCurrentMarketValueForm
                    reportCallBack={x => setIsReportOpen(x)}
                    reportData={concreteCurrentMarketValueReportData}
                    isReportOpen={isReportOpen}
                    registryInfo={selectedRegistry}
                    concurrenceInfo={txtConcurrenceInfo}
                />}
        </div>
    )
}

export default TapuRayicBedel